function Form_form(element) {
    this.$element = $(element);

    this.selectors = {
        form: '.js-form',
        loader: '.js-loader'
    };

    this.modifiers = {
        loaderShown: 'c-form__loader--shown'
    };

    this.triggers = {
	    submitAjaxSuccess: 'i4:submitAjaxSuccess',
		beforeSubmit: 'i4:beforeSubmit'
    };
    
    this.init = function() {
        this.$form = this.$element.find(this.selectors.form);
        this.$loader = this.$element.find(this.selectors.loader);

        this.$form.on(this.triggers.beforeSubmit, () => {
            this.$loader.addClass(this.modifiers.loaderShown);

            window.scrollTo({
                top: this.$element.offset().top + (this.$element.height() / 2) - ($(window).height()/2),
                left: 0,
                behavior: 'smooth'
            });

        });

        this.$form.on(this.triggers.submitAjaxSuccess, (event, parameter) => {
            this.$loader.removeClass(this.modifiers.loaderShown);
            this.$form.remove();
            this.$element.prepend(parameter.notification);

            window.scrollTo({
                top: this.$element.offset().top,
                left: 0,
                behavior: 'smooth'
            });
        });
    };
}
